export const KBViewerNavButton = () => {
  return null;
};
